"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PencilIcon = function PencilIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M11.013 2.974l2.122 2.12-7.711 7.745-2.123-2.123zM1.11 15l2.956-1.298-1.603-1.631zM14.794 2.021l-.707-.707a1 1 0 0 0-1.414 0l-.708.707 2.123 2.123.707-.709a.999.999 0 0 0-.001-1.414z"
    }) : _react["default"].createElement("path", {
      d: "M14.792 2.666l-1.414-1.413a.965.965 0 0 0-1.385-.03l-1.444 1.444-8.763 8.72L.03 15.481a.371.371 0 0 0 .488.488l4.096-1.756 8.763-8.72-.001-.001.002.002 1.443-1.444a.965.965 0 0 0-.03-1.385zM1.569 14.431l.554-1.293.74.739zm2.338-.924l-1.414-1.414 7.963-7.92 1.414 1.415zm8.67-8.626l-1.413-1.414 1.29-1.29a.306.306 0 0 1 .433 0l.981.98a.306.306 0 0 1 0 .433z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M2 22l1.71-4.016 2.305 2.305zM20.34 6.128l-2.504-2.412L4.841 16.81l2.408 2.408zm2.3-3.006L20.937 1.42a.465.465 0 0 0-.372-.128.644.644 0 0 0-.397.19L18.99 2.661 21.4 5.07l1.178-1.18a.55.55 0 0 0 .062-.768z"
    }) : _react["default"].createElement("path", {
      d: "M22.939 2.825l-1.763-1.763a1.203 1.203 0 0 0-1.726-.037L3.55 16.927l-2.343 5.465a.306.306 0 0 0 .403.402l5.465-2.342 14.1-14.102v-.002l.002.002 1.8-1.8a1.203 1.203 0 0 0-.037-1.725zm-4.848.974l2.111 2.11L6.91 19.203l-2.112-2.11zm-13.88 14.12l1.871 1.87-3.273 1.403zM22.27 3.843l-1.36 1.36L18.8 3.09l1.358-1.359a.163.163 0 0 1 .121-.054.285.285 0 0 1 .193.092l1.76 1.762c.018.017.171.178.038.311z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M6.714 22.922L22.148 7.488l2.84 2.84L9.555 25.763zm1.642 3.774l-2.578-2.577-1.958 4.456a.415.415 0 0 0-.016.075.607.607 0 0 0 .104-.026zm17.757-21.84a.943.943 0 0 0-1.333 0l-1.566 1.566 2.84 2.84 1.567-1.566a.943.943 0 0 0 0-1.333z"
  }) : _react["default"].createElement("path", {
    d: "M29 6.02a1.515 1.515 0 0 0-.444-1.071L27.05 3.444a1.515 1.515 0 0 0-2.143 0L5.338 23.014l-.016.015.007.007-2.32 5.387a.433.433 0 0 0 .568.569l5.387-2.32.007.006.016-.016L26.471 9.178l.707-.707 1.378-1.378A1.515 1.515 0 0 0 29 6.02zM4.491 27.51l1.599-3.713 2.113 2.114zm4.48-2.246L6.736 23.03 23.53 6.236l2.235 2.235zM27.849 6.386L26.47 7.764l-2.235-2.235 1.378-1.378a.515.515 0 0 1 .729 0l1.506 1.505A.513.513 0 0 1 28 6.02a.521.521 0 0 1-.151.365z"
  }));
};

var _default = PencilIcon;
exports["default"] = _default;